module.exports = __webpack_public_path__ + "static/img/monitor.bc36426.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/monitor.jpg
// module id = xyWM
// module chunks = 0